// extracted by mini-css-extract-plugin
module.exports =  {"embed":"embed--JseNU","empty":"empty--bQ8TS"};